
import shp from "shpjs";


interface IGeojsonReader {
    read: (file: File) => any
};

type GeoJsonReaderConfig = {
    reader: any,
    extensions: string[]
};

class ZippedShapeFileReader implements IGeojsonReader {
    async read(file: File) {
        try {
            let arrayBuffer = await readFileAsync(file);
            return await shp(arrayBuffer);
        } catch(error) {
            console.error(error);
            throw new Error('ZippedShapeFileReader: error parsing shapefile.');
        }
    };
}

const readerConfigs: GeoJsonReaderConfig[] = [{
        reader: ZippedShapeFileReader,
        extensions: ['zip']
    }
];

export class GeojsonConverterFactory {
    static create(extension: string): IGeojsonReader {
        const extensionLower = extension.toLowerCase();

        const readerConfig = readerConfigs.find((config: GeoJsonReaderConfig) => {
            return config.extensions.indexOf(extensionLower) !== -1;
        });

        if(!readerConfig) {
            throw new Error('Reader for extension not found.');
        }

        return new readerConfig.reader() as IGeojsonReader;
    }
}

function readFileAsync(file: File) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
  
      reader.onload = () => {
        resolve(reader.result);
      };
  
      reader.onerror = reject;
  
      reader.readAsArrayBuffer(file);
    });
}


